<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <div v-if="list_ids.length == 0" class="f-grid-ind">
          <div class="f-grid-col-ind" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
            <div class="ind-text">Công ty</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Khu vực</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="areas_obj.limit" :loading="areas_obj.loading" v-model="areas" :options="areas_obj.items" :total="areas_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Bộ phận</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="department_obj.limit" :loading="department_obj.loading" v-model="department" :options="department_obj.items" :total="department_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Công việc</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="work_obj.limit" :loading="work_obj.loading" v-model="work" :options="work_obj.items" :total="work_obj.total" @keyup="emitEventWork" @offset="changeOffsetWork" :showClear="true"/>
            </div>
          </div>
        </div>
        <div v-if="list_ids.length > 0" class="" style="height: 50px;background-color:#EBF9FF;border-radius: 5px;margin-bottom: 5px;">
          <div class="" style="text-align: right;margin: 10px;">
            <Button
              label="Đã Hủy"
              @click="showChangeStatusDialog('CANCEL')"
              class="p-button-warning return-style-button"
              style="width: 85px;"
            />
            <Button
              label="Không duyệt"
              @click="showChangeStatusDialog('NOT_APPROVE')"
              class="p-button-warning return-style-button"
              style="width: 100px;margin-left: 5px"
            />
            <Button
              label="Đã duyệt"
              @click="showChangeStatusDialog('APPROVE')"
              class=""
              style="width: 85px;margin-left: 5px"
            />
          </div>
        </div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model.sync="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
          :company="company"
          :areas="areas"
          :department="department"
          :work="work"
          v-on:action-list_select_item="action_list_select_item"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc chắn muốn xoá biện pháp kiểm soát này khỏi danh sách?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Thực hiện biện pháp kiểm soát"
          :visible.sync="showRegulationsDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <div style="width: 350px;">
            <span>Mọi người đang tuân thủ theo biện pháp kiểm soát </span><span style="font-weight: 600;">{{control_measures_name}}</span><span> hay không?</span>
          </div>
          
          <div v-if="status_check=='YES'" style="display:flex">
            <Button label="Tuân thủ" @click="clickYes()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 50%;"/>
            <Button label="Không tuân thủ" @click="clickNo()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 50%;"/>
          </div>
          <div v-else style="display:flex">
            <Button label="Tuân thủ" @click="clickYes()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 50%;"/>
            <Button label="Không tuân thủ" @click="clickNo()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 50%;"/>
          </div>
          <div v-if="status_check=='NO'" style="padding-top: 6px;width:100%">
            <label class="txt-right required" style="font-weight: 600;margin-bottom:0px !important">Kiến nghị</label>
            <Textarea style="width:100%" v-model="note" type="text" rows="2" placeholder="Nhập"/>
          </div>
          
          <div style="padding-top: 6px;">
            <label class="txt-right" style="font-weight: 600;margin-bottom:0px !important">File đính kèm</label>
            <input class="input_tmp_validator" id="files">
            <div class="cus-text">Dung lượng tối đa: 50 MB</div>
            <div class="cus-text">Định dạng file: PNG, JPG, JPEG, docx, doc, xlsx, pptx, pdf.</div>
            <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".png, .jpg, .jpeg, .docx, .doc, .xlsx, .xls, .pptx, .pdf" name="files[]" type="file" @change="onFileSelect"/>
            <div class="box-images text-box-a"  v-if="files && files.length > 0">
              <div class="d-flex align-items-center" v-for="(item, index) in files" :key="index" >
                <div class="file-name">{{ item.name }}</div>
                <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
                <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear(index)"/>
              </div>
            </div>
      
          </div>
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showRegulationsDialog = false"
          icon="pi pi-times"
          class="p-button-warning-o callback-btn-o"
          />
          <Button label="Xác nhận" @click="updateRegulations()" icon="pi pi-check" class="" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Cập nhật trạng thái"
          :visible.sync="showChangeStatus"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
        <div style="max-width: 300px;">
          Bạn có chắc muốn cập nhật trạng thái biện pháp kiểm soát là <span style="font-weight: 600;">{{status_change_text}}</span> không?"
        </div>
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showChangeStatus = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xác nhận" @click="UpdateStatus()" icon="pi pi-check" class="" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      popupWarning: false,
      areas : {},
      areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department : {},
      department_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      work : {},
      work_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      status_check: "YES",
      text_status : "",
      showRegulationsDialog : false,
      control_measures_id : null,
      files : [],
      maxFiles: 10,
      maxFileSize: 10485760*5,
      regulations: 'YES',
      listTypeFile: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/doc",
        "application/xls",
        "application/pptx",
      ],
      control_measures_name : "",
      note : "",
      status_change : "",
      status_change_text : "",
      showChangeStatus : false,
      list_ids : [],
      evaluation_form_danger_id : null,
    }
  },
  async created() {
    await this.initParams();
    await this.getListCompany()
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    'company'() {
      // if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      //   this.company_id = this.company.id;
      // }
      // var query = Object.assign({}, this.$route.query);
      // if(this.company && this.company.id){
      //   query.company_id = this.company.id
      // }else{
      //   delete query.company_id;
      // }
      // this.$router.replace({ query });
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.clearAreas()
        this.clearDepartment()
        this.getListAreas()
        this.getListDepartment()
      }
    },
    async 'areas'(){
      console.log("======")
      this.componentKey++;
    },
    async 'department'(){
      this.clearWork()
      this.getListWork()
      // this.componentKey++;
    },
    async 'work'(){
      this.componentKey++;
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_objs = res.data.data.company
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        this.company_id = this.$store.getters?.company_id;
        this.getListAreas()
        this.getListDepartment()
        // this.componentKey++
      }else{
        if (!this.$commonFuction.isEmpty(this.$route.query)){
          if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
            if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.company = {id: this.$route.query.company_id};
              // setTimeout(() => {
              //   const query = Object.assign({}, this.$route.query);
              //   delete query.company_id;
              //   this.$router.replace({ query });
              // }, 100);
            }
          }
        }
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.efd_id)){
        //gọi detail phiếu
        this.evaluation_form_danger_id = this.$route.query.efd_id;
        await this.defaultFilter()
        //xóa để load lại thì lấy full
        setTimeout(() => {
          const query = Object.assign({}, this.$route.query);
          delete query.efd_id;
          this.$router.replace({ query });
        }, 100);
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      if (this.$router.currentRoute.path == '/admin/reviews_control_measures') {
        await this.$set(this, 'title', 'Đánh giá hiệu lực BPKS');
      }
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.control_measures && that.$store.getters.controllers?.control_measures.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `control_measures/add`, title: 'Thêm'};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.control_measures && that.$store.getters.controllers?.control_measures.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `control_measures/edit/`, title: 'Sửa'};
        }
        if (that.$store.getters.controllers?.control_measures && that.$store.getters.controllers?.control_measures.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id', title: 'Xóa'};
        }
        if (that.$store.getters.controllers?.control_measures && that.$store.getters.controllers?.control_measures.includes('history')) {
          buttons.history = {name: 'history',path:'control_measures/history', icon: '', key: 'id', title: 'Lịch sử'};
        }
        
        if(rowData.type == 'LOOP'){
          if(that.$store.getters.controllers?.control_measures && that.$store.getters.controllers?.control_measures.includes('regulations')){
            // if(rowData.status == 'APPROVE'){
            //   if(!rowData.regulations){
                buttons.evaluation = {name: 'evaluation', icon: '', key: 'id', title: 'Đánh giá'};
            //   }
            // }
          }
        }else{
          if(rowData.project_id){
            if(that.$store.getters.controllers?.list_project && that.$store.getters.controllers?.list_project.includes('edit')){
              buttons.view = { name: 'view', icon: 'eye', key: 'project_id', path: `list-project/detail/`};
            }
          }
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        // console.log("buttons",buttons)
        return buttons
      }
      return actions
    },
    clickYes(){
      this.status_check = "YES"
      this.note = ''
    },
    clickNo(){
      this.status_check = "NO"
      this.note = ''
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    },
    async onActionClicked(payload) {
      // console.log("payload==",payload)
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key],query: {company_id: this.company?.id }  })
          }
          // alert("chưa phát triển")
          // this.dialogMode = action.name
          // if (action.path !== undefined && action.path) {
          //   this.$router.push({ path: action.path + data.data[action.key] })
          // } else  {
          //   this.editId = data.data[action.key]
          //   this.displayDialog = true
          //   this.editDialogKey++
          // }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
        case 'evaluation':
          // console.log("data-evaluation",data.data)
          this.control_measures_id = data.data.id
          this.control_measures_name = data.data.name
          this.note = ''
          this.showRegulationsDialog = true
          break
        case 'history':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.$router.push({ path: action.path ,query: {company_id: this.company?.id ,cm_id:data.data.id}  })
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/control_measures/delete", {control_measures_id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
          that.$commonFuction.is_loading(false);
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          })
        })
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      // console.log(keyword);
      this.$delete(this.department_obj.filters, 'name');
      if (keyword) {
        this.department_obj.filters.name = keyword;
      }
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.department_obj.filters.active = true;
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    emitEventWork(keyword) {
      // console.log(keyword);
      this.$delete(this.work_obj.filters, 'name');
      if (keyword) {
        this.work_obj.filters.name = keyword;
      }
      this.getListWork();
    },
    changeOffsetWork(value) {
      this.work_obj.offset = value;
    },
    async getListWork() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.$delete(this.work_obj.filters, 'department_id');
      if(!this.$commonFuction.isEmptyObject(this.department)){
        this.work_obj.filters.department_id = this.department.id
      }
      this.work_obj.filters.active = true
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        this.work_obj.loading = true;
        await ApiRepository.post("/_api/work/options", {filters: this.work_obj.filters, limit: this.work_obj.limit, offset: this.work_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.work_obj.offset > 0 ) {
            this.work_obj.items.push(...res.data.data.list);
          } else{
            this.work_obj.items = res.data.data.list;
          }
          this.work_obj.total = res.data.data.total;
          this.work_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.work_obj.loading = false;
        })
      }
    },
    clearAreas(){
      this.areas_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.areas = {}
    },
    clearWork(){
      this.work_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.work = {}
    },
    clearDepartment(){
      this.department_obj ={
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.department = {}
    },
    isImage(file) {
      // return /^image\//.test(file.type);
      console.log("file.type",file.type)
      return this.listTypeFile.includes(file.type);
    },
    async onFileDownload(index) {
      let file = this.files[index];
      window.open(file.objectURL);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 10) {
          event.target.value = "";
          alert("Chỉ được upload tối đa 10 ảnh");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "PNG", "JPG", "JPEG", "png", "jpg", "jpeg",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: PNG, JPG, JPEG, docx, doc, xlsx, pptx, pdf"
            );
            return;
          }
        }
        if (files.length + this.files.length > this.maxFiles) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFiles + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                arrTemp.push(file);
              }
              if (file.size > this.maxFileSize) arrFiles.push(file);
            // }
          }
          console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            this.files = this.files.concat.apply(this.files, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let file = this.files[index];
      this.files.splice(index, 1);
      if (file.file === "" && file.id) this.filesDeletes.push(file.id);
    },
    async updateRegulations(){
      this.$commonFuction.is_loading(true);
      //gọi api cập nhật trạng thái
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var files = this.files
      var that = this
      if(this.status_check == 'NO'){
        if(this.note == ''){
          alert("Vui lòng nhập kiến nghị.")
          this.$commonFuction.is_loading(false);
          return
        }
      }
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var objects = {
          control_measures_id : this.control_measures_id,
          status_check : this.status_check,
          company_id : this.company.id,
          note : this.note
        }
        
        await ApiRepository.post("/_api/control_measures/change_regulations", objects, {headers}).then(async function (response) {
          if (response.status === 200) {
            if (files && files.length > 0){
              files.map(async file => {
                await that.$CoreService.uploadImages(that.$constants.FOLDER_S3.HISTORY_MEASURES, [file]).then((resImage) => {
                  if (resImage) {
                    var objectImage = resImage[0];//lấy 1 tấm hình
                    that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.HISTORY_MEASURES, response.data.data.id, objectImage).then(() => {
                      console.log("OK")
                    }).catch(async error => {
                        console.log('error', error);
                        that.$toast.add({
                            severity: 'error',
                            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                            detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                            life: 3000
                        });
                        that.$commonFuction.is_loading(false);
                    });
                  }
                });
              });
            }
            that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cập nhật thành công', life: 3000 })
            that.reloadPage();
            // that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
         
          that.showStatusDialog = false
          that.showStatusApproveDialog = false
          that.$commonFuction.is_loading(false);
        })
      }
    },
    reloadPage(){
      this.componentKey++
      this.showRegulationsDialog = false
      this.$commonFuction.is_loading(false);
    },
    showChangeStatusDialog(status){
      var status_change_text = ''
      var status_change = status
      if(status == 'CANCEL'){
        status_change_text = 'Đã hủy'
      }else if(status == 'NOT_APPROVE'){
        status_change_text = 'Không duyệt'
      }else if(status == 'APPROVE'){
        status_change_text = 'Đã duyệt'
      }
      this.status_change = status_change
      this.status_change_text = status_change_text
      this.showChangeStatus = true
    },
    async UpdateStatus(){
      this.$commonFuction.is_loading(true);
      //gọi api cập nhật trạng thái
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var objects = {
          list_ids : this.list_ids,
          status : this.status_change,
          company_id : this.company.id,
        }
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this
        await ApiRepository.post("/_api/control_measures/update_status_multiple", objects, {headers}).then(async function (response) {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cập nhật thành công', life: 3000 })
            that.showChangeStatus = false
            that.reloadPage();
          }
        }).catch((err) => {
          if(err.response && err.response.data && err.response.data.message == "STATUS_NOT_CHANGE"){
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: "Danh sách bạn chọn tồn tại biện pháp không thể thay đổi trạng thái.",
              life:10000
            });
          }else{
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
            });
          }
          that.showStatusDialog = false
          that.showStatusApproveDialog = false
          that.showChangeStatus = false
          that.$commonFuction.is_loading(false);
        })
      }
    },
    action_list_select_item(data) {
      this.list_ids = data
    },
    async defaultFilter() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var object = {
          id : this.evaluation_form_danger_id,
          company_id: this.company.id
        }
        var data = null
        await ApiRepository.post("/_api/evaluation_form_danger/detail_normal", object, {headers}).then(async (res) => {
          data = res.data.data
        })
        // console.log("data===",data)
        if(data){
          var evaluation_form_name = data.evaluation_form.name
          var situation_name = ''
          var danger_name = ''
          if(data.situation && data.situation.type == 'other'){
            situation_name = data.other_situation_name
          }else{
            situation_name = data.situation.name
          }
          if(data.danger && data.danger.type == 'other'){
            danger_name = data.other_danger_name
          }else{
            danger_name = data.danger.name
          }
          var obj = {
            evaluation_form_name : evaluation_form_name,
            situation_name: situation_name,
            danger_name : danger_name,
          }
          console.log("obj==",obj)
          this.filters =obj
        }
      }
      this.componentKey++;
    },
  },
}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}

/* .p-button-warning .pi-times{
  color: #e95d57;
} */
.f-grid-ind {
  display: flex;
  margin-left: -1rem;
  flex-flow: row wrap;
}

.f-grid-col-ind {
  width: 25% !important;
  padding: 0rem 0rem 0rem 1rem;
}
.ind-text { 
  font-weight: 600;
}
.idn-sel {
  margin-top: -6px;
}
.p-button-warning-o .p-button-label{
  color: #333333;
}
.p-button-warning-o .pi-times{
  color: #333333;
}
.callback-btn-o {
  border-color: #00000029 !important;
  background-color: #00000029 !important;
}
.text-box-a{
  display: block;
  width : 100%;
}
</style>